import { urlFormat } from "../seo/seo-helper";
import { getSiteBaseUrl } from "./site-helper";

export const getPdpUrlById = (
  propertyId: string | null,
  propertyName?: string | null,
  propertyCity?: string | null,
  propertyState?: string | null,
  filterURL: string = ""
): string => {
  const filterURLQuery = filterURL ? `?${filterURL}` : "";
  return propertyId
    ? `${getSiteBaseUrl("PDP")}${[
        propertyName ? urlFormat(propertyName, false) : null,
        propertyCity ? urlFormat(propertyCity, false) : null,
        propertyState ? urlFormat(propertyState, false) : null,
      ]
        .filter(Boolean)
        .join("-")}/p_${propertyId}${filterURLQuery}`
    : "#";
};
